<template>
  <div>
    <dc-layout-main aside-width="400px">
      <template #aside>
        <RuleManage :listData="listData" @selectTag="selectTag"></RuleManage>
      </template>
      <template #main>
        <SaleCue></SaleCue>
      </template>
    </dc-layout-main>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue'
import RuleManage from './components/RuleManage.vue'
import SaleCue from './components/SaleCue.vue'

import type { IndexEchart } from '@/types/index'

export default defineComponent({
  components: { RuleManage, SaleCue },
  setup() {
    const listData = [
      { Text: '活动类型', Value: '28' },
      { Text: '关联市场活动', Value: '20' },
      { Text: '服务需求', Value: '21' },
      { Text: '线索无效原因', Value: '22' },
      { Text: '拉黑原因', Value: '23' },
      { Text: '服务主体', Value: '24' },
      { Text: '商机类型', Value: '25' },
      { Text: '市场线索来源', Value: '26' },
      { Text: '渠道状态', Value: '27' },
      { Text: '流失原因', Value: '19' },
      { Text: '合作模式', Value: '29' },
      { Text: '客群类型', Value: '30' },
      { Text: '渠道类别', Value: '31' },
      { Text: '活动费用', Value: '32' },
      { Text: '头程订单-国内仓库', Value: '33' },
      { Text: '头程订单-目的国仓库', Value: '34' },
      { Text: '头程订单-运输方式', Value: '35' },
      { Text: '头程订单-竞争对手', Value: '36' },
      { Text: '需求海外仓', Value: '10' },
      { Text: '潜在收入', Value: '2' },
      { Text: '客户来源', Value: '3' },
      { Text: '在售电商平台', Value: '4' },
      { Text: '目前使用ERP', Value: '5' },
      { Text: '目前合作海外仓', Value: '6' },
      { Text: '客户业务类型', Value: '7' },
      { Text: '销售品类', Value: '8' },
      { Text: '货物类型', Value: '9' },
      { Text: '客户区域', Value: '1' },
      { Text: '头程补货频次', Value: '11' },
      { Text: '渠道名称', Value: '12' },
      { Text: '仓库名称', Value: '13' },
      { Text: '拜访方式', Value: '14' },
      { Text: '访客目的', Value: '15' },
      { Text: '首重区间', Value: '16' },
      { Text: '来源渠道', Value: '17' },
      { Text: '人员类型', Value: '18' }
    ]
    const selectTagName = ref<IndexEchart.RuleManageList>()
    const selectTag = (tagName: IndexEchart.RuleManageList) => {
      console.log('tagName: ', tagName)
      selectTagName.value = tagName
    }
    return { listData, selectTag, selectTagName }
  }
})
</script>
<style lang="scss" scoped></style>
